<template>
    <az-container>
        <az-form>
            <menu-tabs-todas-homologacao/>

            <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                          :pagination.sync="paginacaoInterna" :loading="false" :style="cssVar"
                          no-data-text="Não há compras diretas cadastradas" hide-actions
                          class="az-table-list table-todas-compras">
                <template slot="items" slot-scope="props">
                    <tr >
                        <td @click.stop.prevent="$emit('acessar', props.item)">
                            {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoData(props.item.dataHoraEncerramento)) }}<br>
                            <span v-if="props.item.dataHoraEncerramento">
                                {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoHora(props.item.dataHoraEncerramento)) }}
                            </span>
                        </td>
                        <td @click.stop.prevent="$emit('acessar', props.item)">
                            {{ props.item.processo }}
                            <br>
                            <span v-if="props.item.quantidadeRepeticoes">
                               <strong> Repetição: {{props.item.quantidadeRepeticoes}} </strong>
                            </span>
                        </td>
                        <td @click.stop.prevent="$emit('acessar', props.item)">
                            <expansao-texto :tamanho="125" :texto="props.item.objeto ? props.item.objeto : ''"/>
                        </td>
                        <td @click.stop.prevent="$emit('acessar', props.item)">
                            {{ props.item.tipo | cdEnum(tiposCompraDireta)}}
                        </td>
                        <td @click.stop.prevent="$emit('acessar', props.item)">
                            {{ props.item.orgao }}
                        </td>
                        <td @click.stop.prevent="$emit('acessar', props.item)">
                            {{ props.item.situacao | azEnum(situacoesCompraDireta) }}
                        </td>
                        <td class="table-actions" >
                            <v-tooltip top
                                       v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                                       v-if="devePermitirRepeticaoSGC(props.item)" >
                                <a slot="activator">
                                    <i class="fas fa-undo pr-2" id="repetir" @click.stop.prevent="$emit('repetirCompra', props.item)" aria-hidden="true"/>
                                </a>
                                Repetir Compra
                            </v-tooltip>
                            <v-tooltip top
                                       v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                                       v-if="props.item.situacao === 'EM_ELABORACAO'" >
                                <a slot="activator">
                                    <i class="fas fa-trash-alt pr-2" id="excluir" @click.stop.prevent="$emit('excluir', props.item.id)" aria-hidden="true"/>
                                </a>
                                Excluir Compra
                            </v-tooltip>
                            <v-tooltip top>
                                <a slot="activator">
                                    <i class="fas fa-sign-in-alt pr-2" aria-hidden="true" @click="$emit('acessar', props.item)"/>
                                </a>
                                Acessar
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.sequencialCompraPublica">
                                <a @click="$emit('acessarPncp', props.item)" slot="activator">
                                    <i class="fas fa-external-link-alt pr-2" aria-hidden="true"/>
                                    <span class="acao-mobile">Acessar no PNCP</span>
                                </a>
                                Acessar no PNCP
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.pncpMensagemErro">
                                <a slot="activator">
                                    <i class="fas fa-exclamation-triangle icon-alert-pncp" aria-hidden="true"></i>
                                    <span class="acao-mobile">{{props.item.pncpMensagemErro}}</span>
                                </a>
                                {{props.item.pncpMensagemErro}}
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <div class="az-pagination">
                <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                <div class="az-select-pagination">
                    <span>Linhas por página:</span>
                    <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                </div>
            </div>
        </az-form>
    </az-container>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesCompraDireta, tiposCompraDireta} from '@/core/constants'
import MenuTabsTodasHomologacao from '@/views/pages/comprador/components/MenuTabsTodasHomologacao.vue'

export default {
    name: 'TodasComprasDiretasTabela',
    components: {MenuTabsTodasHomologacao},
    props: ['itens', 'paginacao', 'paginas', 'totalItens'],

    data() {
        return {
            situacoesCompraDireta,
            colunas: [
                {
                    text: 'Encerramento',
                    value: 'dataHoraEncerramento',
                    sortable: true,
                    align: 'left',
                    width: '40px',
                    class: 'primary--text'
                },
                {
                    text: 'Nº Processo',
                    value: 'processo',
                    sortable: true,
                    align: 'left',
                    width: '100px',
                    class: 'primary--text'
                },
                {
                    text: 'Objeto',
                    value: 'objeto',
                    sortable: true,
                    align: 'left',
                    width: '200px',
                    class: 'primary--text'
                },
                {
                    text: 'Tipo',
                    value: 'tipo',
                    sortable: true,
                    align: 'left',
                    width: '80px',
                    class: 'primary--text'
                },
                {
                    text: this.$t('main.comprador_todas_compras_diretas_orgao.text'),
                    value: 'orgao',
                    sortable: false,
                    align: 'left',
                    width: '40px',
                    class: 'primary--text'
                },
                {
                    text: 'Situação',
                    value: 'situacao',
                    sortable: true,
                    align: 'left',
                    width: '60px',
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    sortable: false,
                    align: 'center',
                    width: '30px',
                    class: 'primary--text'
                }
            ],
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
            tiposCompraDireta
        }
    },
    computed: {
        ...mapState(['loki', 'parametros']),
        cssVar() {
            const labelOrgao = this.$t('main.comprador_todas_compras_diretas_orgao.text')
            return {
                '--label-orgao': `"${labelOrgao}:"`
            }
        },
    },
    methods: {
        devePermitirRepeticaoSGC(item){
            return item.origem === 'SGC' && item.permiteRepetir
        },
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .icon-alert-pncp
        color #ffb703

    .az-container
        margin-bottom 60px

    .table-todas-compras
        .acao-mobile
            display none

        td:hover
            cursor pointer !important

    @media (max-width 720px)
        .table-todas-compras
            td:nth-of-type(1):before
                content "Encerramento:"

            td:nth-of-type(2):before
                content "Nº Processo:"

            td:nth-of-type(3):before
                content "Objeto:"

            td:nth-of-type(4):before
                content "Tipo:"

            td:nth-of-type(5):before
                content var(--label-orgao)

            td:nth-of-type(6):before
                content "Situação:"

            td:nth-of-type(7):before, td:nth-of-type(1) br
                display none

            .acao-mobile
                display inline-block
                margin-left 3px

    @media (max-width 500px)
        .az-container
            margin 0
</style>
